
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 90.886 90.842"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('linearGradient',{attrs:{"id":"a","x1":".842","y1":"1","x2":".124","y2":"1","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#218665"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#218665"}})])]),_c('g',{attrs:{"fill":"url(#a)"}},[_c('path',{attrs:{"d":"M86.716 82.581H4.13a4.13 4.13 0 000 8.261h82.585a4.13 4.13 0 000-8.261zM9.292 71.84a4.131 4.131 0 000 8.263h72.261a4.131 4.131 0 000-8.263h-1.03V34.678h1.031a2.064 2.064 0 100-4.127H9.292a2.064 2.064 0 000 4.127h1.032V71.84H9.292zm62.97-37.162V71.84H59.875V34.678zm-20.648 0V71.84H39.227V34.678zm-33.033 0h12.387V71.84H18.581zM4.13 26.838h82.625a4.131 4.131 0 001.34-8.038L47.12.362a4.138 4.138 0 00-3.388 0L2.436 18.943a4.129 4.129 0 001.694 7.9z"}})])])
          )
        }
      }
    